import { render, staticRenderFns } from "./BorrowPanel.vue?vue&type=template&id=1821817a&scoped=true"
import script from "./BorrowPanel.vue?vue&type=script&lang=js"
export * from "./BorrowPanel.vue?vue&type=script&lang=js"
import style0 from "./BorrowPanel.vue?vue&type=style&index=0&id=1821817a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821817a",
  null
  
)

export default component.exports